<template>
    <div class="meta discount-wrapper" v-if="hasSale(item)">
        <div class="ui labels">
            <a class="ui bright-yellow label">Akcija! {{getDiscountPercentage(item)}}%</a>
        </div>
    </div>
</template>

<script>

export default {
    props: ['item'],
    data() {
      return {
      }
    },
    computed: {
        goods() {
        //loaded from parent
        return this.$store.state.goodStore.topgoods
        },
        cart() {
        return this.$store.state.cartStore.activeCart
        },
        cartItems() {
            return this.$store.state.cartStore.items
        }
    },
    created() {
    },
    methods: {
        checkIfInCart(item){
            if(this.$store.state.cartStore.items.length > 0 && this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id }).length > 0) return true;
            else return false;
        },
        hasSale(item) {
            return parseFloat(item.base_price_old_vat) > parseFloat(item.base_price_vat);
        },
       getDiscountPercentage(item) {
           return (((parseFloat(item.base_price_vat) / parseFloat(item.base_price_old_vat)) - 1) * 100).toFixed(0);
       }
    }
}

</script>
<style>
.bright-yellow {
    background-color: #FFCC00 !important;
    color: #212121 !important;
    font-size: 13px !important;
    max-height: 25.1px;
}

.discount-wrapper {
    margin-top: 0px;
    margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// Discount.vue?2e22dcb8